import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastLetter',
})
export class LastLetterPipe implements PipeTransform {
  transform(string: string): string {
    return string.slice(-1);
  }
}
